import React, { useEffect, useState } from "react";

interface User {
  title: string;
  firstName: string;
  lastName: string;
}

interface Props {
  user: User;
}

export const UserNameDisplay: React.FC<Props> = ({ user }) => {
  const [displayName, setDisplayName] = useState<string>(
    `${user.title} ${user.firstName} ${user.lastName}`
  );
  const [isOverflow, setIsOverflow] = useState<boolean>(false);

  const containerRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current) {
        setIsOverflow(
          containerRef.current.scrollWidth > containerRef.current.clientWidth
        );
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => {
      window.removeEventListener("resize", checkOverflow);
    };
  }, [user]);

  useEffect(() => {
    if (isOverflow) {
      setDisplayName(`${user.title} ${user.firstName} ${user.lastName[0]}.`);
    } else {
      setDisplayName(`${user.title} ${user.firstName} ${user.lastName}`);
    }
  }, [isOverflow, user]);

  return (
    <div
      ref={containerRef}
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {displayName}
    </div>
  );
};
